import React, { useState, useEffect } from 'react';
import { useApolloNetworkStatus } from '@ts-private/apollo-tools-ts';
import { networkStatusLinkConfig as config } from 'apollo/config';
import { LinearProgress } from '@totalsoft/rocket-ui';

const GlobalLoadingIndicator = () => {
  const [pending, setPending] = useState(false);
  const status = useApolloNetworkStatus(config);

  useEffect(() => {
    setPending(status.pendingQueryCount > 0 || status.pendingMutationCount > 0);
  }, [status]);

  return pending ? <LinearProgress global /> : <></>;
};

export default GlobalLoadingIndicator;
